import { useAppSelector } from 'src/App/redux/hooks';
import { RootState } from 'src/App/redux/store';
import { LayoutContain } from './Layout.styles';

export default function Layout({ children }) {
	const platform = useAppSelector((state: RootState) => state.app.platform);

	return <LayoutContain platform={platform}>{children}</LayoutContain>;
}
